export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";